import { UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { StateService } from '../../../services/state.service';

@Component({
  selector: 'app-tenant-avatar',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UpperCasePipe],
  templateUrl: './tenant-avatar.component.html',
  styleUrl: './tenant-avatar.component.scss',
})
export class TenantAvatarComponent {
  public state = inject(StateService);
  @Input() tenant: { favicon_url: string; id: string; name: string } =
    this.state.activeTenant || this.state.sharedWithMeActiveTenant;
  @Input() showActive: boolean;
}
